import store, { notesSlice } from '../../store'
import { protoRoot, socketio } from '../../protos'
import socketApi from './api'
import md5 from 'blueimp-md5'
import nyanyalog from 'nyanyajs-log'
import { RSA, DiffieHellman, deepCopy } from '@nyanyajs/utils'
// import { e2eeDecryption } from './common'
// import { getDialogRoomUsers } from '../../store/modules/chat/methods'

import { client } from '../../store/nsocketio'
import { notesMethods } from '../../store/notes'

export const createSocketioRouter = {
	createRouter() {
		const { nsocketio, api, config } = store.getState()
		if (!client) return
		// const state = store.state
		const namespace = nsocketio.namespace
		const NSocketIoEventNames = api.NSocketIoEventNames
		// // console.log(deepCopy(client), namespace, namespace.base)

		client
			?.routerGroup(namespace.base)
			.router({
				eventName: NSocketIoEventNames.v1.Error,
				func: (response) => {
					console.log('Socket.io Error', response)
					switch (response.data.code) {
						case 10009:
							// store.state.event.eventTarget.dispatchEvent(
							// 	new Event('initEncryption')
							// )
							break
						case 10004:
							// store.state.event.eventTarget.dispatchEvent(new Event('initLogin'))
							break

						default:
							break
					}
				},
			})
			.router({
				eventName: NSocketIoEventNames.v1.OtherDeviceOnline,
				func: (response) => {
					console.log('OtherDeviceOnline', response)
				},
			})
			.router({
				eventName: NSocketIoEventNames.v1.OtherDeviceOffline,
				func: (response) => {
					console.log('OtherDeviceOffline', response)
				},
			})
			.router({
				eventName: NSocketIoEventNames.v1.OnForceOffline,
				func: (response) => {
					console.log('OnForceOffline', response)
				},
			})

		client?.routerGroup(namespace.sync).router({
			eventName: NSocketIoEventNames.v1.SyncData,
			func: socketio.ResponseDecode<protoRoot.sync.SyncData.IResponse>(
				(res) => {
					// console.log('SyncData', res)
          console.log("------SyncData------")
					if (res.data.code === 200) {
						if (config.sync) {
							store.dispatch(notesMethods.SyncData(res.data.data))
						}
					}
					// const res = socketio.ResponseDecode<protoRoot.sync.SyncData.IResponse>(
					// 	response,
					// 	protoRoot.sync.SyncData.Response
					// )
				},
				protoRoot.sync.SyncData.Response
			),
		})
	},
}
export default createSocketioRouter
